module.exports = __webpack_public_path__ + "applabmarketingwp4cbaa98b0e572c92f029b7f7a15c3ac0.png";